import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';

import {
    AuthProvider,
    FetchProvider,
    NavProvider,
    ToastProvider,
    RestApiProvider,
    UserProvider,
    InsightProvider,
    MenuProvider
} from './components/contexts';

import { Routes } from './components/routing';
import { Layout } from './components/layout';

const theme = createTheme({
    palette: {
        primary: {
            main: "#c2a07b"
        },
        secondary: {
            main: "#515151"
        },
        text: {
            secondary: "#c2a07b"
        }
    },
    overrides: {
        MuiStepIcon: {
            root: {
                '&$active': {
                    color: "#c2a07b",
                },
                '&$completed': {
                    color: "#d1d1d1",
                },
            },
        },
        MuiSwitch: {
        },
        MuiCheckbox: {
            colorSecondary: {
                color: '#c2a07b',
                '&$checked': {
                    color: '#c2a07b',
                },
            },
        },
        MuiTabs: {
            indicator: {
                backgroundColor: "#c2a07b"
            }
        }
    }
});

const App = (props) => {
    return (
        <ThemeProvider theme={theme}>
            <InsightProvider>
                <SnackbarProvider preventDuplicate maxSnack={5}>
                    <ToastProvider>
                        <AuthProvider>
                            <FetchProvider>
                                <RestApiProvider>
                                    <NavProvider>
                                        <UserProvider>
                                            <MenuProvider>
                                                <Layout>
                                                    <Routes />
                                                </Layout>
                                            </MenuProvider>
                                        </UserProvider>
                                    </NavProvider>
                                </RestApiProvider>
                            </FetchProvider>
                        </AuthProvider>
                    </ToastProvider>
                </SnackbarProvider>
            </InsightProvider>
        </ThemeProvider>
    );
};

export default App;